import React, { useState, useEffect } from "react";
import "./ApprovalModal.css";
import { useCompanyContext } from "../hooks/useCompanyContext";

const ApprovalModal = ({ isOpen, onClose, order, onApprove }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useCompanyContext();

  useEffect(() => {
    if (isOpen) {
      setIsChecked(false);
      setIsSubmitting(false);
    }
  }, [isOpen, order?.no]);

  if (!isOpen) return null;

  const handleApprove = async () => {
    if (!isChecked || isSubmitting) return;

    try {
      setIsSubmitting(true);
      await onApprove(order.no);
      onClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{t.orderGoedkeuren}</h2>

        <div className="pdf-section">
          <h3>{t.betreftOrder} {order?.no || "Onbekend"}</h3>
          <iframe
            src={`${order?.orderPdf || ""}#zoom=page-fit&navpanes=0&pagemode=none`}
            title="Order PDF"
            width="100%"
            height="1024px"
          />
        </div>

        <div className="pdf-section">
          <h3>{t.algemeneVoorwaarden}</h3>
          <iframe
            src={`${order?.termsPdf1 || ""}#zoom=page-fit&navpanes=0&pagemode=none`}
            title="Voorwaarden PDF"
            width="100%"
            height="1024px"
          />
          <iframe
            src={`${order?.termsPdf2 || ""}#zoom=page-fit&navpanes=0&pagemode=none`}
            title="Voorwaarden PDF"
            width="100%"
            height="1024px"
          />
        </div>

        <div className="approval-section">
          <label>
            {t.voorwaardenAccepteren}
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => setIsChecked((prev) => !prev)}
              disabled={isSubmitting}
            />
          </label>
        </div>

        <div className="modal-buttons">
          <button
            onClick={handleApprove}
            className="approve-button"
            disabled={!isChecked || isSubmitting}
          >
            {isSubmitting ? "Bezig..." : t.goedkeuren}
          </button>

          <button
            onClick={onClose}
            className="close-button"
            disabled={isSubmitting}
          >
            {t.annuleren}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApprovalModal;